import i18n from '@fiverr/i18n/singleton';
import { getContext } from '@fiverr-private/fiverr_context';
import { injectTemplates, shouldInjectTemplates } from '../shared/injectTemplates';

/**
 * Wrapper to i18n.t that encapsulates the need to add $scope:locale in render flow (CSR, SSR), while also providing `templates` support.
 * @param {String} key - String representing dot notation of the translation key
 * @param {Object} options - the options param that enables customization when needed.
 * @param {Object} options.params - Interpolation params
 * @param {Object} options.templates - Custom template to interpolate
 * @param {String} options.locale - Custom locale, usually when used outside the render flow (CSR, SSR)
 * @returns {String | React.Component} - Translated and interpolated string or a React Component
 */
const translate = (key, options = {}) => {
    if (!key) {
        throw new Error('key must be provided to `translate`.');
    }

    let locale;

    if (options.locale) {
        locale = options.locale;
    } else {
        locale = getContext().locale;
    }

    const data = {
        ...options.params,
        $scope: locale
    };

    let output;
    try {
        output = i18n.t(key, data);
    } catch (e) {
        output = key;
    }

    if (shouldInjectTemplates(output)) {
        return injectTemplates(output, options.templates);
    }

    return output;
};

export default translate;
